import { useState } from "react";
import { Button, CircularProgress, TextField } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Calendar, Download, FileText, Search } from "react-feather";
import { DateRangePicker } from "rsuite";
import styles from "../reports.module.css";
import { exportCSV, exportPDF } from "./exportUtils";

/**
 * Filter bar shared by every report: search, date range, optional extra
 * filters (children) and CSV / PDF export of the full filtered dataset.
 */
const ReportToolbar = ({ report, columns, title, filename, searchPlaceholder = "Search", showDateFilter = true, children }) => {
    const [exporting, setExporting] = useState("");

    const handleExport = (type) => {
        setExporting(type);
        report.fetchAll().then((rows) => {
            if (type === "csv") {
                exportCSV(columns, rows, `${filename}.csv`);
            } else {
                exportPDF(title, columns, rows, `${filename}.pdf`);
            }
            setExporting("");
        }).catch(() => {
            setExporting("");
        });
    };

    const exportDisabled = exporting !== "" || report.total === 0;

    return (<div className={`${styles.TableFilterHead}`}>
        <div className={`${styles.FilterGroup}`}>
            <div className={`${styles.SearchWrap}`}>
                <Search className={`${styles.SearchIcon}`} />
                <TextField
                    variant="standard"
                    type="text"
                    placeholder={searchPlaceholder}
                    value={report.search}
                    onChange={(e) => report.setSearch(e.target.value)}
                    className={`${styles.SearchInput}`}
                    InputProps={{ disableUnderline: true }}
                    inputProps={{ "aria-label": "Search" }}
                    fullWidth
                />
                {report.search !== "" && (
                    <Button type="button" className={`${styles.ClearBU}`} onClick={() => report.setSearch("")} aria-label="Clear search">
                        <Close />
                    </Button>
                )}
            </div>

            {children}

            {showDateFilter && (<div className={`${styles.DateFilter}`}>
                <DateRangePicker
                    format={"dd/MM/yyyy"}
                    placement={"bottomEnd"}
                    placeholder="Filter by date"
                    caretAs={Calendar}
                    value={report.dateRange}
                    showOneCalendar
                    block
                    onChange={(value) => report.setDateRange(value)}
                />
            </div>)}
        </div>

        <div className={`${styles.ExportGroup}`}>
            <Button className={`${styles.ExportBU}`} onClick={() => handleExport("csv")} disabled={exportDisabled}>
                {exporting === "csv" ? <CircularProgress size={16} color="inherit" /> : <Download />} CSV
            </Button>
            <Button className={`${styles.ExportBU} ${styles.ExportBUPrimary}`} onClick={() => handleExport("pdf")} disabled={exportDisabled}>
                {exporting === "pdf" ? <CircularProgress size={16} color="inherit" /> : <FileText />} PDF
            </Button>
        </div>
    </div>);
};

export default ReportToolbar;
